const TransactionsTab = ({ transactions, safeFormat }) => {
  return (
    <div className="bg-[#0B0F19] rounded-xl border border-[#D4AF37]/10 overflow-hidden">
      <div className="p-4 border-b border-[#D4AF37]/10">
        <h3 className="font-['Playfair_Display'] text-xl text-white">Sales Transactions</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="transactions-table">
          <thead className="bg-white/5">
            <tr>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Date</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Plan</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Amount</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Affiliate</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((t) => (
              <tr key={t.id} className="border-t border-white/5">
                <td className="p-4 text-white/50 text-sm">{safeFormat(t.created_at, 'MMM d, yyyy HH:mm')}</td>
                <td className="p-4 text-white capitalize">{t.plan_id?.replace('_', ' ')}</td>
                <td className="p-4 text-white font-bold">€{t.amount?.toFixed(2)}</td>
                <td className="p-4 font-mono text-[#D4AF37] text-sm">{t.affiliate_code || '-'}</td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${t.payment_status === 'paid' ? 'bg-[#047857]/20 text-[#047857]' : 'bg-yellow-500/20 text-yellow-400'}`}>
                    {t.payment_status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {transactions.length === 0 && (
          <p className="p-8 text-center text-white/40">No transactions yet</p>
        )}
      </div>
    </div>
  );
};

export default TransactionsTab;
